import { Box, Grid, Typography } from '@mui/material'
import InstallmentApi, { CancelInstallment } from 'api/finances/installment.api'
import PaymentInstallmentBox, { PaymentInstallmentListProps } from 'component/Treatments/PaymentInstallment/PaymentInstallment'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import SelectInput from 'new-components/inputs/select-input'
import TextAreaInput from 'new-components/inputs/text-area-input'
import TextInput from 'new-components/inputs/text-input'
import PageModal from 'new-components/modal/page-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { numberFormat } from 'utils/app.utils'

type PopInstallmentChangeProps = {
  open: boolean
  onClose: () => void
  onReload: () => void
  data: any
}

const PopInstallmentChange = (props: PopInstallmentChangeProps) => {
  const { t } = useTranslation()

  const { open, onClose, onReload, data } = props

  const [paymentInstallmentList, setPaymentInstallmentList] = useState<PaymentInstallmentListProps[]>([])
  const [popInstallmentCancel, setPopInstallmentCancel] = useState<boolean>(false)

  const onSubmit = async () => {
    if (handleInstallmentCheck() && data?.installmentPaymentId) {
      const payload: { installmentList: PaymentInstallmentListProps[] } = {
        installmentList: paymentInstallmentList.map((item: any, index: number) => {
          const { installmentPaymentId, patientCaseId, receiptNumber, updatedBy
            , vnNumber, installmentPaidDate, ...rest } = item
          const newId = item?.installmentId || 0
          return { ...rest, installmentId: newId, installmentNumber: index + 1, }
        })
      }
      await InstallmentApi.update(data?.installmentPaymentId, payload).then((res: any) => {
        onClose()
        notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'))
        onReload()
      }).catch((err: any) => notiError(t("INSTALLMENT.MESSAGE.ERROR.ERROR")))
    }
  }

  const onOpenPopCancelInstallment = () => {
    setPopInstallmentCancel(true)
  }

  const onClosePopCancelInstallment = (reload: boolean) => {
    setPopInstallmentCancel(false)
    if (reload) {
      onClose()
      onReload()
    }
  }

  useEffect(() => {
    setPaymentInstallmentList((prev) => [...data?.installmentList])
  }, [])

  const handleInstallmentCheck = () => {
    const totalInstallmentList = paymentInstallmentList.reduce((total: number, item) => total += item?.price || 0, 0)
    if (data?.totalPrice !== totalInstallmentList) {
      notiError(t('INSTALLMENT.POPUP_MANAGE_TREATMENT.MESSAGE.ERROR.TOTAL_INSTALLMENT'))
      return false
    }
    return true

  }

  return (
    <>
      <PageModal
        title={t('INSTALLMENT.POPUP_CHANGE.TITLE')}
        size={'M'}
        isOpen={open}
        handleClose={onClose}
        onCancel={{ onClick: onClose }}
        onSubmit={{ onClick: onSubmit }}
        btnLeft={{
          title: t('INSTALLMENT.POPUP_CHANGE.BUTTON.CANCEL'),
          onClick: onOpenPopCancelInstallment,
          type: 'danger',
          variant: 'outlined',
          sx: { textWrap: 'nowrap', width: 'fit-content' }
        }}
        overflow
      >
        <Box>
          <Box display={'flex'} alignItems={'center'} gap={'16px'} marginTop={'16px'}>
            <Typography fontWeight={500}>{t('INSTALLMENT.POPUP_CHANGE.OP_CODE')}:{` ${data?.operativeCode || '-'}`}</Typography>
            <Typography fontWeight={500}>{t('INSTALLMENT.POPUP_CHANGE.OP_NAME')}:{` ${data?.operativeName || '-'}`}</Typography>
          </Box>
          <Box marginTop={'16px'}>
            <Box>
              <Typography className="mt-2" sx={{ fontWeight: 500 }}>
                {t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TITLE')}
              </Typography>
            </Box>
            <Box margin={'16px 0'}>
              <SelectInput
                label={t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TITLE')}
                onChange={(e) => console.log()}
                options={[{ name: t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_LNSTALLMENT'), value: "1" }]}
                value={"1"}
                disabled
              />
            </Box>

            <Box>
              <Box marginBottom={'16px'}>
                <TextInput
                  fullWidth
                  label={t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TOTAL')}
                  disabled
                  onChange={(event) => console.log()}
                  value={numberFormat(data?.totalPrice || 0)}
                />
              </Box>

              <Box padding={{ md: "0 24px", sm: '0px' }}>
                <PaymentInstallmentBox
                  operativeTotal={data?.totalPrice}
                  paymentInstallmentList={paymentInstallmentList}
                  setPaymentInstallmentList={(prev) => {
                    setPaymentInstallmentList(prev)
                  }}
                />
              </Box>
            </Box>

          </Box>
        </Box>
      </PageModal>

      {popInstallmentCancel &&
        <PopInstallmentCancel
          id={data?.installmentPaymentId || 0}
          open={popInstallmentCancel}
          onClose={onClosePopCancelInstallment} />
      }
    </>
  )
}

export default PopInstallmentChange

type PopInstallmentCancelProps = {
  id: number
  open: boolean
  onClose: (reload: boolean) => void

}
const PopInstallmentCancel = (props: PopInstallmentCancelProps) => {
  const { t } = useTranslation()

  const { id, open, onClose } = props

  const [dataInstallmentCancel, setDataInstallmentCancel] = useState<CancelInstallment>({ username: '', password: '', cancelRemark: '' })
  const [errorMessage, setErrorMessage] = useState<{ username: string, password: string, }>({ username: '', password: '', })

  const onSubmit = async () => {
    const errMessage = {
      username: !dataInstallmentCancel?.username ? t("INSTALLMENT.POPUP_CANCEL.MESSAGE.ERROR.USERNAME") : '',
      password: !dataInstallmentCancel?.password ? t("INSTALLMENT.POPUP_CANCEL.MESSAGE.ERROR.PASSWORD") : '',
    }
    if (Object.values(errMessage).some((item) => item !== '')) {
      setErrorMessage(errMessage)
      return
    } else {
      setErrorMessage({ username: '', password: '' })
      await InstallmentApi.cancel(id, dataInstallmentCancel).then((res: any) => {
        onClose(true)
      }).catch((err) => {
        const msg = ['ไม่พบผู้ใช้งาน', 'รหัสผ่านไม่ถูกต้อง']
        if (msg.includes(err?.response?.data?.message)) {
          notiError(t("INSTALLMENT.POPUP_CANCEL.MESSAGE.ERROR.USER_NONEFOND"))
        } else {
          notiError(t("INSTALLMENT.POPUP_CANCEL.MESSAGE.ERROR.ERROR"))
        }
      })
    }
  }

  return (
    <PageModal
      title={t('INSTALLMENT.POPUP_CANCEL.TITLE')}
      size={'S'}
      isOpen={open}
      handleClose={() => onClose(false)}
      onCancel={{ onClick: () => onClose(false) }}
      onSubmit={{ onClick: onSubmit, type: 'danger', title: t('BUTTON.SUBMIT') }}
    >
      <Box>
        <Box>
          <Typography>{t('INSTALLMENT.POPUP_CANCEL.DETAIL')}</Typography>
        </Box>
        <Box marginTop={'16px'}>
          <Grid container>
            <Grid item xs={6}>
              <Box padding={'12px 8px'}>
                <TextInput
                  required
                  onChange={(event) => setDataInstallmentCancel((prev) => ({ ...prev, username: event.target.value }))}
                  label={t('INSTALLMENT.POPUP_CANCEL.FORM.USERNAME')}
                  fullWidth
                  value={dataInstallmentCancel.username}
                  helperText={errorMessage.username}
                />
              </Box>

            </Grid>
            <Grid item xs={6}>
              <Box padding={'12px 8px'}>
                <TextInput
                  required
                  onChange={(event) => setDataInstallmentCancel((prev) => ({ ...prev, password: event.target.value }))}
                  label={t('INSTALLMENT.POPUP_CANCEL.FORM.PASSWORD')}
                  fullWidth
                  value={dataInstallmentCancel.password}
                  inputProps={{ type: 'password' }}
                  helperText={errorMessage.password}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box padding={'12px 8px'}>
                <TextAreaInput
                  onChange={(event) => setDataInstallmentCancel((prev) => ({ ...prev, cancelRemark: event.target.value }))}
                  fullWidth
                  value={dataInstallmentCancel.cancelRemark}
                  label={t('INSTALLMENT.POPUP_CANCEL.FORM.REMARK')}
                  maxLength={500}
                  inputProps={{
                    style: {
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'flex-start',
                      fontSize: "12px"
                    },
                    startAdornment: (
                      <Box sx={{ position: "absolute", bottom: "2px" }}>
                        <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${dataInstallmentCancel.cancelRemark?.length || 0}/500`}</Box>
                      </Box>
                    ),
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </PageModal>
  )
}